<template>
  <div class="prestart">
    <div>
      你好，欢迎参加比赛!
    </div>
    <div>
      如果你是在家参赛, 请加入腾讯会议，进入会议后请修改昵称为真实姓名
    </div>
    <div class="numbers">
      <span class="number" v-for="(num, index) in meetings">会议号码：{{num}}</span>
    </div>
    
    <my_button :value="'下一步'" :inputStyle="buttonStyle" @click.native="next"></my_button>
  </div>
</template>

<script>
  import MyButton from '@/components/Button.vue';
export default {
  components: {
    my_button: MyButton,
  },
  data () {
    return {
      meetings: [
        '360819105'
      ]
    }
  },
  computed: {
              buttonStyle() {
        return {
          'border-radius': '5px',
          'margin-top': '2vw',
          'width': '8em'
        }
      },

  },
  methods: {
    next () {
      const data = new FormData()
      data.set('language', 'python')
      this.$http.post('/api/final/classroom/join', data).then(res => {
        this.$emit("next")
      })
    }
  }
}
</script>

<style scoped>
.prestart {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.color {
  color: #fa5151;
}
</style>
